import { render } from "./TransitionOverlay.vue?vue&type=template&id=e0465232"
import script from "./TransitionOverlay.vue?vue&type=script&lang=js"
export * from "./TransitionOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__